export const getTimeDescription = (obj: { timeDescription: string | null }) =>
  obj.timeDescription || "";

export default getTimeDescription;
